// main.js
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.min.css'
import '@fortawesome/fontawesome-free/css/all.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

import { createApp } from 'vue';
import { createI18n } from 'vue-i18n';
import App from './App.vue';
import router from './router'
import { createVuetify } from 'vuetify';
import { fa } from 'vuetify/iconsets/fa'
import { mdi } from 'vuetify/iconsets/mdi'
import { md } from 'vuetify/iconsets/md'
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import apiClientPlugin from './plugins/apiClient';
import store from './store';
import { messages } from './locales';

export const i18n = createI18n({
  locale: store.getters.currentLocale,
  fallbackLocale: 'defaultLocale',
  messages,
});

store.watch(
  (state) => state.settings.locale,
  (newLocale) => {
    i18n.global.locale = newLocale;
  }
);


const dark = {
  dark: true,
  colors: {
    background: '#213542',
    surface: '#263e4e',
    primary: '#fff',
    'primary-darken-1': '#1a292f',
    secondary: '#424242',
    'secondary-darken-1': '#1b1b1b',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FB8C00',
  },
};

const light = {
  dark: false,
  colors: {
    background: '#F5F5F5',
    surface: '#FFFFFF',
    primary: '#1976D2',
    'primary-darken-1': '#1565C0',
    secondary: '#424242',
    'secondary-darken-1': '#212121',
    error: '#D32F2F',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFA000',
  },
};

const vuetify = createVuetify({
  theme: {
    defaultTheme: 'light',
    themes: {
      dark:dark,
      light:light,
    },
  },
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    sets: {
      mdi,
      md,
      fa
    },
  },
});

const app = createApp(App);
app.use(router);
app.use(vuetify);
app.use(store);
app.use(apiClientPlugin);
app.use(i18n);

// Provide $launchUrl globally for inject in components
app.provide('$launchUrl', (url) => {
  window.parent.postMessage({ action: 'openUrl', url: url }, 'https://project-overview.dashboards.rdrive.io');
  window.open(url, '_blank');
});

app.mount('#app');
